export default __webpack_public_path__ + "static/media/bg.c69dd585.png";